/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import AccountMenuNew from './AccountMenuNew';
import BasicMenu from './BasicMenu';
import LogoNew from '../logo/LogoNew';
import MobileMenu from './MobileMenu';
import NavMenuNew from './NavMenuNew';
import PortalNav from './PortalNav';
import ToggleMobileMenu from './ToggleMobileMenu';

import { isAuthenticated } from '../../utils/authChecker';

import './MainNavNew.scss';
import ReactTooltip from "react-tooltip";
import suspiciousIcon from "../../images/quest-state/suspicious.png";

function MainNavNew({
  auth,
  brandUser,
  isBrandUser,
  isAdmin,
  isClientPortal,
  pathname,
  router,
  subdomain,
  toggleMyQuestsMenu,
  user,
  visible,
  getReconciliationStatus,
  reconciliation
}) {
  if (!visible) return null;
  const [fadingOut, setFadingOut] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobile, setMobile] = useState(window.innerWidth < 768);
  const [reconciliationCount, setReconciliationCount] = useState(false);

  useEffect(() => {
    const update = () => {
      if (mobile && (window.innerWidth >= 768)) {
        setMobile(false);
      } else if (!mobile && (window.innerWidth < 768)) {
        setMobile(true);
      }
    };

    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [mobile]);

  useEffect(() => {
    if(!isAdmin){
      return;
    }

    const fetchData = ()=>{
      getReconciliationStatus()
          .then(result=>{
            setReconciliationCount(result||0)
            // console.log('ÿ60��ִ��һ��', new Date().toLocaleTimeString(),result);
          })
          .catch(error => {
            console.error('reconciliationCounts fail', error);
          });
    }
    const intervalId = setInterval(fetchData, 6000*10*60);
    fetchData();
    // �������������ж��ʱ�����ʱ��
    return () => {
      clearInterval(intervalId);
    };
  }, []); // ���������飬ȷ��ֻ����һ�ζ�ʱ��

  const closeMenu = () => {
    if (window.innerWidth < 768) {
      setMenuOpen(false);
    }
  };

  const toPayment = () =>{
    router.push(`/admin/payments`);
  }

  const toggleMenu = () => setMenuOpen(!menuOpen);
  if (pathname === '/make-some-noiz') return null;
  const authenticated = isAuthenticated();
  const inAboutUs = pathname === '/about-us';
  const inAboutNOIZ3 = pathname === '/about-us-beta3';
  const inBrandService = pathname === '/';
  const inContact = pathname === '/contact';
  const inSearchLight = pathname === '/searchlight';
  const inCareers = pathname.startsWith('/careers');
  const inGame = pathname.startsWith('/game');
  const inOnboard = pathname === '/onboard';
  const inHatchway = pathname === '/brand/hatchway';
  const inPrivacyPolicy = pathname === '/privacy-policy';
  const inRoot = pathname === '/';
  const inTermsOfUse = pathname === '/terms-of-use';
  const isBrands = (subdomain === 'brands' || subdomain === 'brands.staging');
  const inStreamWithUs = pathname === '/stream-with-us';

  const showBasicMenu = ((inRoot || inAboutUs || inAboutNOIZ3 || inBrandService || (inContact && !authenticated) ||(inSearchLight && !authenticated) || inCareers || (inGame && !authenticated) || inOnboard || inHatchway || inTermsOfUse || inPrivacyPolicy || inStreamWithUs)
    && ['staging', '', 'localhost', '172.16','127.0','gp','gp.snail.com'].includes(subdomain) && !isClientPortal && !mobile);

  const headerClassNames = classNames(
    'Main__Header',
    {
      Portal: isClientPortal,
      'basic-menu': showBasicMenu,
      white: isBrands,
    },
  );

  const wrapperClassNames = classNames(
    'Main__Header__wrapper',
    {
      borderBottom: inAboutUs || inRoot || pathname.startsWith('/quest'),
      forceFullWidth: pathname === '/admin',
    },
  );

  return (
    <header className={headerClassNames}>
      <section className={wrapperClassNames}>
        <LogoNew black={isBrands} />
        <PortalNav
          campaign={brandUser.campaign}
          campaigns={brandUser.campaigns}
          router={router}
          visible={isClientPortal}
        />
        <BasicMenu
          authenticated={authenticated}
          visible={showBasicMenu}
        />
        <MobileMenu
          authenticated={authenticated}
          closeMenu={closeMenu}
          fadingOut={fadingOut}
          isBrands={isBrands}
          isAdmin={isAdmin}
          isBrandUser={isBrandUser}
          isClientPortal={isClientPortal}
          visible={mobile && menuOpen}
        />
        <NavMenuNew
          auth={auth}
          brandUser={brandUser}
          isBrandUser={isBrandUser}
          isAdmin={isAdmin}
          isClientPortal={isClientPortal}
          router={router}
          toggleMyQuestsMenu={toggleMyQuestsMenu}
          user={user}
          visible={!mobile && !showBasicMenu && authenticated}
          reconciliationCount={reconciliationCount}
        />
        <AccountMenuNew
          auth={auth}
          isBrandUser={isBrandUser}
          visible={!mobile && authenticated && !showBasicMenu}
        />
        <ToggleMobileMenu
          fadingOut={fadingOut}
          open={menuOpen}
          setFadingOut={setFadingOut}
          toggleMenu={toggleMenu}
          visible={mobile && !(isClientPortal && !authenticated)}
        />
        {(isAdmin&&reconciliationCount > 0) && (
            <>
              <ReactTooltip
                  place="bottom" // �� "left" ��Ϊ "bottom"
                  effect="solid"
                  offset={{ top: 10 }} // �� { left: 10 } ��Ϊ { top: 10 }�����·�����һ���ռ�
                  delayShow={200}
              />
              <p data-tip="There is an anomaly in the payment data. Please check it promptly!">
                <img
                    src={suspiciousIcon}
                    onClick={toPayment}
                    style={{ color: '#dd4a41', margin: '15px 20px' ,width:'20px',cursor:'pointer'}}
                    alt={''}
                />
              </p>
            </>
        )}
      </section>
    </header>
  );
}

export default MainNavNew;
